import classNames from 'classnames'
import { useState } from 'react'

import styles from './SaltInfoButton.module.scss'

const SaltInfoButton = () => {
  const [infoOpen, setInfoOpen] = useState(false)

  return (
    <>
      <button
        aria-label='Learn about the EDHREC salt score'
        className={styles.trigger}
        onClick={() => setInfoOpen(true)}
        title='Info'
      >
        ?
      </button>

      {infoOpen && (
        <div className={classNames(styles.infoContainer, 'shadow-sm')}>
          <div className={styles.content}>
            <button className={styles.closeContainer} onClick={() => setInfoOpen(false)}>
              x
            </button>
            <iframe
              allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
              allowFullScreen
              className={styles.frameStyle}
              frameBorder='0'
              src='https://www.youtube.com/embed/sI_JihFQEqw'
              title='YouTube video player'
            />
          </div>
        </div>
      )}
    </>
  )
}

export default SaltInfoButton
